import { render, staticRenderFns } from "./FooterRight.vue?vue&type=template&id=6c5965c2&scoped=true"
import script from "./FooterRight.vue?vue&type=script&lang=js"
export * from "./FooterRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5965c2",
  null
  
)

export default component.exports